import React from 'react'
import PropTypes from 'prop-types'
import { QRCodeSVG } from 'qrcode.react'
import HobnobModal from 'components/common/HobnobModalV2/HobnobModal'
import { DOWNLOAD_APP_LINK } from 'src/constants'
import styles from './qr-code-download-app-modal.scss'
import qrCodeDownloadModalBg from 'assets/qr-code-download-modal-bg.png'
import HobnobLogo from 'src/assets/icons/ico-hobnob-logo.svg'
import SvgIcon from 'src/components/common/SvgIcon'
import CloseIconWhite from 'assets/icons/close_white.png'

const QRCodeDownloadAppModal = (
  {
    show,
    onClose,
    title,
    href = DOWNLOAD_APP_LINK
  }
) => {
  const renderCloseIcon = (
    <div className={styles['close-icon']}>
      <img src={CloseIconWhite} width="17" alt="close" />
    </div>
  )
  return (
    <HobnobModal
      visible={show}
      onCancel={onClose}
      fullModal
      closable
      closeIcon={renderCloseIcon}
    >
      <div className={styles['download-wrapper']}>
        <SvgIcon className={styles['hobnob-logo']} icon={HobnobLogo} />
        <img className={styles['download-app-modal-bg']} src={qrCodeDownloadModalBg} alt="" />

        <div className={styles['text']}>{title}</div>

        <div className={styles['qr-code-container']}>
          <div className={styles['qr-code']}>
            <QRCodeSVG value={href} size={220} />
          </div>
        </div>
      </div>
    </HobnobModal>
  )
}

QRCodeDownloadAppModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  href: PropTypes.string
}

export default QRCodeDownloadAppModal
